export const GROUPING_ATTRIBUTE = 'groupingAttribute';
// export const SPACER_ROW_VALUE = '---';
